<div class="dynamic-element">
    <app-hint [text]="element.hint"></app-hint>
    <ng-template appDynamicComponentHost></ng-template>
</div>
